import React, { useRef } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Card} from 'react-bootstrap'
import GifButton2 from './GifButton2';

export default function Box(props) {
  const gifButtonRef = useRef();

  function handleCardClick() {
    if (gifButtonRef.current) {
      gifButtonRef.current.trigger();
    }
  }


  return (
    <div className="rainbow-border" >
      <Card className='card-3d-strong'  style={{ width:'10rem', height:'13rem'}} onClick={handleCardClick} >
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
        <Card.Title className="text-center pt-0 pb-0">{props.title}</Card.Title>
          <GifButton2 ref={gifButtonRef} imageStatic={props.imageStatic} imageGif={props.imageGif} imageAlt={props.imageAlt} audioVoice={props.audioVoice}/>
      </Card.Body>
      </Card>
    </div>
    
    
  )
}

